import React from "react";
import Img from "gatsby-image";
import Section from "../section/Section";
import ButtonLink from "../links/ButtonLink";
import cssClass from "./ClinicHeader.module.scss";

const ClinicHeader = ({
  name,
  phone,
  email,
  address,
  location,
  image,
  bookAppointmentLink,
  getDirectionsLink,
}) => {
  const renderTextContent = (
    <div className={cssClass.content}>
      <h1 className={cssClass.title}>{name}</h1>

      <div className={cssClass.details}>
        <div className={cssClass.contactDetails}>
          <div className={cssClass.phone}>{phone}</div>
          <a href={`mailto:${email}`} target="_blank" rel="noreferrer noopener">
            {email}
          </a>
        </div>

        <div className={cssClass.address}>
          <div
            dangerouslySetInnerHTML={{
              __html: address.childMarkdownRemark.html,
            }}
          />
          {location && (
            <p className="smallText boldText">
              <a href={location} target="_blank" rel="noreferrer noopener">
                {getDirectionsLink}
              </a>
            </p>
          )}
        </div>
      </div>

      <ButtonLink className={cssClass.ctaButton} to="/" alternativeInvert>
        {bookAppointmentLink}
      </ButtonLink>
    </div>
  );

  return (
    <div className={cssClass.clinicHeader}>
      <Section className={cssClass.section}>{renderTextContent}</Section>
      {image && (
        <div className={cssClass.imageWrapper}>
          <Img fluid={image.fluid} alt={image.title} />
        </div>
      )}
    </div>
  );
};

export default ClinicHeader;
